import { render, staticRenderFns } from "./FncNotice.vue?vue&type=template&id=4cc38ac2&"
import script from "./FncNotice.vue?vue&type=script&lang=js&"
export * from "./FncNotice.vue?vue&type=script&lang=js&"
import style0 from "./FncNotice.vue?vue&type=style&index=0&lang=scss&slot-scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FncNotice.vue"
export default component.exports